import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ChannelList from './components/ChannelList';
import ChannelDetail from './components/ChannelDetail';
import ShowDetail from './components/ShowDetail';
import EpisodeDetail from './components/EpisodeDetail';
import SegmentManagement from './components/SegmentManagement';
import Panelists from './components/Panelists';
import NewsSearch from './components/NewsSearch';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { theme } from './theme';
import './App.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="channels" element={<ChannelList />} />
              <Route path="channels/:channelId" element={<ChannelDetail />} />
              <Route path="shows/:showId" element={<ShowDetail />} />
              <Route path="episodes/:episodeId" element={<EpisodeDetail />} />
              <Route path="episodes/:episodeId/segments/:segmentId" element={<SegmentManagement />} />
              <Route path="panelists" element={<Panelists />} />
              <Route path="news-search" element={<NewsSearch />} />
              
              {/* Redirect old nested URLs to new simplified structure */}
              <Route path="channels/:channelId/shows" element={<Navigate to="/channels/:channelId" replace />} />
              <Route path="channels/:channelId/shows/:showId" element={<Navigate to="/shows/:showId" replace />} />
              <Route path="channels/:channelId/shows/:showId/episodes" element={<Navigate to="/shows/:showId" replace />} />
              <Route path="channels/:channelId/shows/:showId/episodes/:episodeId" element={<Navigate to="/episodes/:episodeId" replace />} />
              
              {/* Redirect simplified nested URLs that don't exist */}
              <Route path="shows/:showId/episodes" element={<Navigate to="/shows/:showId" replace />} />
            </Route>
          </Routes>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
